/**
@ngdoc directive
@name excludeFormValidation

@description
Apply on ng-form element - excludes ng-form from validation.
*/
(function() {
  'use strict';

var excludeFormValidation = function () {
    return {
        restrict: 'A',
        require: '?form',
        link: function(scope, element, attrs, formController) {
            if (!formController) {
                return;
            }

            var parentForm = formController.$$parentForm; // Note this uses private API
            if (!parentForm) {
                return;
            }

            // Remove this form from parent controller
            parentForm.$removeControl(formController);
        }
    };
}
angular.module('app').directive('excludeFormValidation', excludeFormValidation);

}());


